export default __webpack_public_path__ + "media/80454a289794c3748fdbc78cc5bbf8470f6160cf3577cc34172bdf4685233449.svg";